<template>
  <v-card>
    <v-container style="max-width: 1500px">
      <v-row>
        <v-col cols="12">
          <v-toolbar color="secondary" flat dense>
            <v-toolbar-title>Payments Reports</v-toolbar-title>
          </v-toolbar>
        </v-col>
      </v-row>

      <v-row class="shortcuts-padding">
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-row dense>
            <v-col cols="12" md="3">
              <v-btn to="/sale-payments-report" text left><v-icon left>mdi-list-box-outline</v-icon> Sale Payments
                Report</v-btn><br />

              <v-btn v-if="userLoaded && !AmayaVersion"  to="/purchase-payments-report" text left><v-icon
                  left>mdi-list-box-outline</v-icon> Purchase Payments Report</v-btn><br />
            </v-col>

          </v-row>
        </v-col>

      </v-row>

      <snackbar ref="snackbar"></snackbar>
    </v-container>
  </v-card>
</template>


<script>
export default {
  components: {},
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
    userId() {
      return localStorage.getItem("userId");
    },
  },
  data() {
    return {
      loader: false,
      loading: false,
      AmayaVersion: true,
      userLoaded: false,
    };
  },
  methods: {
    getUserDetails() {
      const userId = localStorage.getItem("userId");
      this.$store
        .dispatch("get", `/users/${userId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            this.AmayaVersion = res.ResponseData.AmayaVersion == "Y" ? true : false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          this.userLoaded = true;
        })
        .catch((err) => {
          this.userLoaded = true;
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getUserDetails();
  },
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}

.cardText {
  font-weight: bold;
  font-size: 18px;
  padding: 12px;
  color: #757575;
}

.dash-btn {
  margin-top: -5px;
}
</style>